import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as tslib_1 from "tslib";
import React, { useCallback, useState, useEffect, useMemo, useRef } from 'react';
import { isFieldValueFilled } from '../../hooks';
import { FloatingLabel } from '../basic';
import { LocalizeButton as Button } from '../';
import _ from 'lodash';
export var TextboxInput = function TextboxInput(_a) {
  var type = _a.type,
      value = _a.value,
      label = _a.label,
      placeholder = _a.placeholder,
      error = _a.error,
      onfocus = _a.onfocus,
      onblur = _a.onblur,
      onchange = _a.onchange,
      autoFocus = _a.autoFocus,
      allowUnmask = _a.allowUnmask,
      preventPaste = _a.preventPaste,
      prefix = _a.prefix,
      controlledLabel = _a.controlledLabel,
      onLabelStateChange = _a.onLabelStateChange,
      disabled = _a.disabled,
      defaultLabelId = _a.defaultLabelId,
      labelPrefix = _a.labelPrefix,
      children = _a.children,
      step = _a.step,
      rest = tslib_1.__rest(_a, ["type", "value", "label", "placeholder", "error", "onfocus", "onblur", "onchange", "autoFocus", "allowUnmask", "preventPaste", "prefix", "controlledLabel", "onLabelStateChange", "disabled", "defaultLabelId", "labelPrefix", "children", "step"]);

  var name = rest.name,
      extra = tslib_1.__rest(rest, ["name"]);

  var trimOnBlurArray = ['address1', 'address2', 'city', 'state', 'postalCode', 'email', 'Name', 'name', 'description', 'acctSuffix', 'answer', 'employer', 'employmentFunctions', 'jobPosition', 'disclosuresStakeholderTickerSymbol', 'disclosuresGovOfficialImmediateFamily', 'disclosuresGovOfficialPoliticalOrg', 'disclosuresForeignBankUSAgent', 'securityResponse'];

  var checkTrimOnBlurArray = function checkTrimOnBlurArray() {
    return trimOnBlurArray.findIndex(function (n) {
      return defaultLabelId && _.includes(defaultLabelId, n) || _.includes(name, n);
    });
  };

  var isTrimOnBlur = checkTrimOnBlurArray() !== -1 ? true : false;

  var isPhoneNumber = _.includes(name, 'phoneNumber');

  var formatPhoneNumber = function formatPhoneNumber(value) {
    if (!value) return value;
    var phoneNumber = value.replace(/[^\d]/g, '');
    if (phoneNumber.length < 4) return phoneNumber;
    if (phoneNumber.length < 7) return "".concat(phoneNumber.slice(0, 3), "-").concat(phoneNumber.slice(3));
    if (phoneNumber.length <= 10) return "".concat(phoneNumber.slice(0, 3), "-").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6));
    if (phoneNumber.length === 11) return "".concat(phoneNumber.slice(0, 1), "-").concat(phoneNumber.slice(1, 4), "-").concat(phoneNumber.slice(4, 7), "-").concat(phoneNumber.slice(7));else return "".concat(phoneNumber.slice(0, 2), "-").concat(phoneNumber.slice(2, 6), "-").concat(phoneNumber.slice(6));
  };

  var inputRef = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var val = inputValue || value;

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      maskPassword = _useState4[0],
      setMaskPassword = _useState4[1];

  var _useState5 = useState({
    isFilled: isFieldValueFilled(val)
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      floatingLabelState = _useState6[0],
      setFloatingLabelState = _useState6[1];

  var updateFloatingLabelState = useCallback(function (state) {
    setFloatingLabelState(state);

    if (onLabelStateChange) {
      onLabelStateChange(state);
    }
  }, [onLabelStateChange]);
  var onFocus = useCallback(function (e) {
    var input = e ? e.currentTarget : inputRef.current;

    if (!input) {
      return;
    }

    if (onfocus && e) {
      onfocus(e);
    }
    /* Keep isFilled based on value so placeholder clears only when user types, not on focus */


    updateFloatingLabelState({
      isFilled: isFieldValueFilled(input.value),
      hasFocus: true
    });
  }, [onfocus, updateFloatingLabelState]);
  var onBlur = useCallback(function (e) {
    if (isTrimOnBlur) {
      e.target.value = e.target.value.trim();
      onChange(e);
    }

    if (onblur) {
      onblur(e);
    }

    updateFloatingLabelState({
      isFilled: isFieldValueFilled(e.target.value),
      hasFocus: false
    });
  }, [onblur, updateFloatingLabelState]);
  var onChange = useCallback(function (e) {
    var rawValue = e.target.value;
    var val = type === 'number' ? parseFloat(rawValue) : rawValue;

    if (onchange) {
      onchange(e, val);
    } else {
      setInputValue(rawValue);
    }

    updateFloatingLabelState({
      isFilled: isFieldValueFilled(val),
      hasFocus: floatingLabelState.hasFocus
    });
  }, [type, onchange, updateFloatingLabelState, floatingLabelState.hasFocus]);
  var onPaste = useCallback(function (e) {
    if (preventPaste) {
      e.preventDefault();
    }
  }, [preventPaste]);
  var onDragDrop = useCallback(function (e) {
    if (preventPaste) {
      e.preventDefault();
    }
  }, [preventPaste]);
  useEffect(function () {
    if (autoFocus) {
      setTimeout(function () {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100);
    }
  }, [autoFocus]);
  useEffect(function () {
    if (!controlledLabel) {
      updateFloatingLabelState({
        isFilled: isFieldValueFilled(val),
        hasFocus: floatingLabelState.hasFocus
      });
    }
  }, [val, controlledLabel, floatingLabelState.hasFocus, updateFloatingLabelState]);
  var icon = useMemo(function () {
    if (type === 'password' && allowUnmask) {
      return React.createElement(Button, {
        type: maskPassword ? 'show' : 'hide',
        onClick: function onClick() {
          return setMaskPassword(!maskPassword);
        },
        tabIndex: -1
      }, React.createElement("i", {
        className: "fal fa-lg ".concat(maskPassword ? 'fa-eye' : 'fa-eye-slash')
      }));
    }

    return undefined;
  }, [type, maskPassword, allowUnmask]);
  var handleIncrement = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || !inputRef.current) return; // Get current value - prefer the controlled value prop, then fallback to input value

    var currentValueStr = String(val || inputRef.current.value || '');
    var currentValue = parseFloat(currentValueStr) || 0;
    var stepValue = step ? parseFloat(step.toString()) : 1;
    var min = extra.min ? parseFloat(extra.min.toString()) : undefined;
    var max = extra.max ? parseFloat(extra.max.toString()) : undefined;
    var newValue = currentValue + stepValue;
    var finalValue = newValue;
    if (min !== undefined && finalValue < min) finalValue = min;
    if (max !== undefined && finalValue > max) finalValue = max; // Create the new value string

    var newValueString = finalValue.toString(); // Update the input DOM element's value

    if (inputRef.current) {
      var valueDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

      if (valueDescriptor && valueDescriptor.set) {
        valueDescriptor.set.call(inputRef.current, newValueString);
      } else {
        inputRef.current.value = newValueString;
      } // Create and dispatch a proper input event


      var inputEvent = new Event('input', {
        bubbles: true
      });
      inputRef.current.dispatchEvent(inputEvent); // Also create a change event for React/Formik

      var changeEvent = new Event('change', {
        bubbles: true
      });
      inputRef.current.dispatchEvent(changeEvent);
      inputRef.current.focus();
    }
  }, [disabled, step, extra.min, extra.max, val]);
  var handleDecrement = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || !inputRef.current) return; // Get current value - prefer the controlled value prop, then fallback to input value

    var currentValueStr = String(val || inputRef.current.value || '');
    var currentValue = parseFloat(currentValueStr) || 0;
    var stepValue = step ? parseFloat(step.toString()) : 1;
    var min = extra.min ? parseFloat(extra.min.toString()) : undefined;
    var max = extra.max ? parseFloat(extra.max.toString()) : undefined;
    var newValue = currentValue - stepValue;
    var finalValue = newValue;
    if (min !== undefined && finalValue < min) finalValue = min;
    if (max !== undefined && finalValue > max) finalValue = max; // Create the new value string

    var newValueString = finalValue.toString(); // Update the input DOM element's value

    if (inputRef.current) {
      var valueDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

      if (valueDescriptor && valueDescriptor.set) {
        valueDescriptor.set.call(inputRef.current, newValueString);
      } else {
        inputRef.current.value = newValueString;
      } // Create and dispatch a proper input event


      var inputEvent = new Event('input', {
        bubbles: true
      });
      inputRef.current.dispatchEvent(inputEvent); // Also create a change event for React/Formik

      var changeEvent = new Event('change', {
        bubbles: true
      });
      inputRef.current.dispatchEvent(changeEvent);
      inputRef.current.focus();
    }
  }, [disabled, step, extra.min, extra.max, val]);
  var numberButtons = useMemo(function () {
    if (type === 'number') {
      return React.createElement("div", {
        className: "flabel-number-buttons"
      }, React.createElement("button", {
        type: "button",
        className: "flabel-number-button flabel-number-button-up",
        onClick: handleIncrement,
        disabled: disabled,
        tabIndex: -1,
        "aria-label": "Increase value"
      }, React.createElement("i", {
        className: "fal fa-chevron-up"
      })), React.createElement("button", {
        type: "button",
        className: "flabel-number-button flabel-number-button-down",
        onClick: handleDecrement,
        disabled: disabled,
        tabIndex: -1,
        "aria-label": "Decrease value"
      }, React.createElement("i", {
        className: "fal fa-chevron-down"
      })));
    }

    return undefined;
  }, [type, disabled, handleIncrement, handleDecrement]);
  var fieldType = useMemo(function () {
    if (type === 'number') {
      return type;
    }

    if (!maskPassword) {
      return 'text';
    }

    return type;
  }, [maskPassword, type]);
  return React.createElement(React.Fragment, null, React.createElement(FloatingLabel, {
    id: name,
    className: error ? 'invalid' : '',
    label: placeholder || label || name,
    prefix: prefix,
    icon: icon,
    state: floatingLabelState,
    disabled: disabled
  }, React.createElement("input", Object.assign({
    ref: inputRef,
    className: "flabel-input",
    id: name,
    type: fieldType,
    value: isFieldValueFilled(val) ? isPhoneNumber ? formatPhoneNumber(val) : val : '',
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    onPaste: onPaste,
    onDrag: onDragDrop,
    onDrop: onDragDrop,
    autoComplete: name,
    step: step
  }, extra)), numberButtons));
};